import * as angular from 'angular';

import { ComponentDefinition, ContextualField } from '../../models';

class PropertyGridLabelController implements angular.IComponentController {
    icons: string[];
    
    readonly field: ContextualField;
    
    static $inject = [];

    $onChanges(_changesObj: angular.IOnChangesObject) {
        this.init();
    }

    private init() {
        this.icons = (this.field && Array.isArray(this.field.icon))
            ? this.field.icon
            : [this.field.icon as string];
    }
}

export const wtPropertyGridLabel: ComponentDefinition = {
    componentId: 'wtPropertyGridLabel',
    controller: PropertyGridLabelController,
    template: require('./propertyGridLabel.component.html'),
    controllerAs: 'vm',
    bindings: {
        field: '<'
    }
};
